export const DocumentColumnsLabelTranslations = {
    document_type: 'Document - Listview - Columnname - Document',
    template_name: 'Template - Listview - Columnname - Template name',
    user: "Document - Listview - Columnname - Owner",
    recipient_roles: "Document - Listview - Columnname - Recipient",
    organization: "Document - Listview - Columnname - Organization",
    status: "Document - Listview - Columnname - Status",
    status_updated_at: "Latest Activity table column name (document listing table) - Latest Activity",
    metodika_status: "Document - Listview - Columnname - Metodika Status"
}

export const documentTypeSettingColumns = [
    {
        'contract_control_preview': {
            'contract_no': 'Preview tab column contract no - (Contract Control right menu) - Contract no',
            'counter_part': 'Preview tab column counter part - (Contract Control right menu) - Counter part',
            'document_type': 'Preview tab column type - (Contract Control right menu) - Type',
            'category_name': 'Preview tab column category - (Contract Control right menu) - Category',
            'contract_type': 'Preview tab column This is - (Contract Control right menu eg - this is master contract) - This is',
            'start_date': 'Preview tab column start date - (Contract Control right menu) - Start date',
            'end_date': 'Preview tab column end date - (Contract Control right menu) - End date',
            'revenew': 'Preview tab column revenue - (Contract Control right menu) - Revenue',
            'cost': 'Preview tab column cost - (Contract Control right menu) - Cost',
        },
        'contract_control_columns': {
            'contract_control_name': 'Default column name - (Contract control listing section) - column',
            'category_name': 'Default column name - (Contract control listing section) - column',
            'name': 'Default column name - (Contract control listing section) - column',
            'start_date': 'Default column name - (Contract control listing section) - column',
            'end_date': 'Default column name - (Contract control listing section) - column',
            'managers': 'Default column name - (Contract control listing section) - column',
            'contacts': 'Default column name - (Contract control listing section) - column',
            'contract_no': 'Default column name - (Contract control listing section) - column',
            'created_at': 'Default column name - (Contract control listing section) - column',
            'cost': 'Default column name - (Contract control listing section) - column',
            'revenue': 'Default column name - (Contract control listing section) - column'
        },
        'document_preview': {
            'document_type': 'Document type text for details (Documents Section) - Document type',
            'category_name': 'Category label (Document right menu) - Category',
            'saved_in_folder': 'Saved in folder text for details (Documents Section) - Saved in folder',
            'get_shareable_link': 'Get shareable link text for details (Documents Section) - Get shareable link',
            'linked_with': 'Linked with text for details (Documents Section) - Linked with',
            'due_date': 'Due Date text for details (Documents Section) - Due Date',
            'document_owner': 'Document owner text for details (Documents Section) - Document owner',
            'tags': 'Add Tag text for placeholder (Documents Section) - Add Tag',
            'status_updated_at': DocumentColumnsLabelTranslations.status_updated_at
        },
        'document_columns': DocumentColumnsLabelTranslations
    }
]
